import { useState, useEffect } from 'react';
import globalState from '../utils/globalState';

/**
 * Custom hook for managing user parameters
 * Provides optimized access to user data with caching
 * @returns {Object} Object containing user parameter getter functions
 */
export const useUserParams = () => {
  const [userParams, setUserParams] = useState(() => globalState.getAllUserParams());

  // Get all user parameters (optimized version)
  const getAllUserParams = () => {
    const params = globalState.getAllUserParams();
    if (JSON.stringify(params) !== JSON.stringify(userParams)) {
      setUserParams(params);
    }
    return params;
  };

  // Get current user's agentName
  const getCurrentAgentName = () => {
    const params = getAllUserParams();
    return params.agentName;
  };

  // Get current user's agentTitle
  const getCurrentAgentTitle = () => {
    const params = getAllUserParams();
    return params.agentTitle;
  };

  // Get current user's agentNumber
  const getCurrentAgentNumber = () => {
    const params = getAllUserParams();
    return params.agentNumber;
  };

  // Get current user's agentEmail
  const getCurrentAgentEmail = () => {
    const params = getAllUserParams();
    return params.agentEmail;
  };

  // Get current user's brokerage
  const getCurrentBrokerage = () => {
    const params = getAllUserParams();
    return params.brokerage;
  };

  // Get current user's quote
  const getCurrentQuote = () => {
    const params = getAllUserParams();
    return params.quote;
  };

  // Get current user's about
  const getCurrentAbout = () => {
    const params = getAllUserParams();
    return params.about;
  };

  // Get current user's logo
  const getCurrentLogo = () => {
    const params = getAllUserParams();
    return params.logo;
  };

  // Get current user's headshot
  const getCurrentHeadshot = () => {
    const params = getAllUserParams();
    return params.headshot;
  };

  // Initialize user parameters cache and listen for changes
  useEffect(() => {
    const params = globalState.getAllUserParams();
    setUserParams(params);

    // Listen for global state changes
    const unsubscribe = globalState.addListener((state) => {
      const newParams = globalState.getAllUserParams();
      setUserParams(newParams);
    });

    return unsubscribe; // Cleanup listener on unmount
  }, []);

  return {
    getAllUserParams,
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentQuote,
    getCurrentAbout,
    getCurrentLogo,
    getCurrentHeadshot
  };
};

export default useUserParams;

